<script>
import useSharedData from "@/use/SharedData";
import axios from "axios";
import useSharedSelectData from "@/use/SharedSelectData";

export default {
    setup() {
        const {dialog, loading} = useSharedData();
        const {outStateModelFiles} = useSharedSelectData();

        function download(file_name) {
            loading.value = true;
            axios.get("/printed/emptyModel", {
                responseType: "arraybuffer",
                params: {fileName: file_name},
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", file_name);
                document.body.appendChild(link);
                link.click();
            }).finally(() => {
                loading.value = false;
            });
        }

        return {
            dialog,
            loading,
            outStateModelFiles,
            download
        }
    }
};
</script>

<template>
    <v-dialog transition="dialog-bottom-transition" max-width="600">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="blue darken-2"
                class="white--text ml-1"
                depressed
                small
                v-bind="attrs"
                v-on="on"
            >
                {{ $t('out_state_model.blank_modal') }}
                <v-icon right>mdi-download</v-icon>
            </v-btn>
        </template>
        <template v-slot:default="dialog">
            <v-card>
                <w-toolbar color="teal" :title="$t('out_state_model.blank_modal')"/>
                <v-card-text>
                    <v-list dense>
                        <template v-for="(item, index) in outStateModelFiles">
                            <v-list-item :key="`item-${index}`">
                                <v-list-item-title> {{ item.name }} </v-list-item-title>
                                <v-list-item-action>
                                    <v-btn small icon @click="download(item.file)">
                                        <v-icon>mdi-download</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider :key="`d-${index}`" v-if="index < outStateModelFiles.length - 1"/>
                        </template>
                    </v-list>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="dialog.value = false"/>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>